import { withDisplayName } from '@hocs/with-display-name'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { EnhancedLinkUnstyled } from '@ui/enhanced-components/enhanced-components'
import Rating from '@ui/rating'
import { StarsLabelImage } from '@ui/stars-label-image'
import { graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

const ContentfulReviewMobile: Utils.EntryFC<
  Queries.ContentfulReviewMobileFragment
> = ({
  content: { titleReview, subtitleReview, image, text, notation, url, labeled },
  entryInspectorProps,
}) => (
  <EnhancedLinkUnstyled
    className="grid grid-cols-12 gap-6 px-4 py-2 hover:bg-[#0000000a]"
    href={url}
    {...entryInspectorProps()}
  >
    <span className="col-span-4">
      <GatsbyImage
        alt={image.description}
        className="h-[2.8125rem] w-full"
        image={getImage(image)}
        objectFit="contain"
      />
    </span>
    <span className="col-span-8">
      <span className="font-medium">
        {titleReview}
        <span className="text-085 font-normal"> {subtitleReview}</span>
      </span>
      <RichText
        content={text}
        options={defaultRichTextFieldOptionsDeprecated}
      />
      <div className="flex items-center gap-8">
        <div>
          {notation && (
            <Rating className="mb-2" color="green" value={notation} />
          )}

          <span className="font-medium uppercase text-theme-default-main underline">
            En détail
          </span>
        </div>
        <div>{labeled && <StarsLabelImage label={labeled} />}</div>
      </div>
    </span>
  </EnhancedLinkUnstyled>
)

export const query = graphql`
  fragment ContentfulReviewMobile on Contentful4VKja7XjbWkW4WeI4OqeUi {
    ...ContentfulEntry
    titleReview: title
    subtitleReview: subtitle
    labeled
    image {
      description
      gatsbyImageData(formats: [AVIF, WEBP, AUTO])
    }
    notation
    text {
      rich
    }
    url
  }
`

export default withDisplayName(ContentfulReviewMobile, 'ContentfulReviewMobile')
